import React from 'react';
import {connect} from 'react-redux';



class CardInfo extends React.Component{
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (this.props.info.offerType == "venue" && this.props.info.offerContent) {

      window.location = "https://playo.co/booking?venueId=" + this.props.info.offerContent;
    }
    if (this.props.info.offerType == "activity" && this.props.info.offerContent) {
      window.location = "https://playo.co/activity?activityId=" + this.props.info.offerContent;
    }
    if(this.props.offerType == "invite" || !this.props.offerContent){
      window.location = "https://playo.co/download";
    }
  }

    render(){
      try{
        var name = this.props.info.offerName;

      }catch(err){
        console.log(err);

      }

      return (
        <div className="venue-card-info">

        <h2 className="venue-card-title"> {name} </h2>


        </div>
      );
    }

}

function mapStateToProps(state) {
  return {
    location : state.Location,
    allSports : state.SportsFilter
  };
}

export default connect(mapStateToProps)(CardInfo);



// WEBPACK FOOTER //
// ./src/components/Offers/cardInfo.js